'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hoursAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hoursAgo.js
// module id = 682
// module chunks = 0